let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4b20x")).then(() => parcelRequire('jJL9z'));